<template>
  <div class="partial-header">
    <div class="container">
      <button class="hidden-md hidden-lg btn btn-lg btn-link pull-right" style="margin-top: 9px;" @click="toggleDrawer()">
        <i class="fa fa-bars"></i>
      </button>
      <header>
        <div class="navbar-header">
          <router-link :to="{name: 'home'}" class="navbar-brand brand">
            <img :src="imageUrl('locashop-logo-header.png', '160')" alt="Loca.Shop - Aluguel online de produtos" class="logo">
          </router-link>
        </div>
        <ul class="nav navbar-nav navbar-right hidden-xs hidden-sm">
          <li>&nbsp;&nbsp;&nbsp;</li>
          <li v-if="!user && !['login', 'sku_checkout'].includes(routeName)"><router-link :to="{name: 'login'}" class="btn btn-link bold font-18">LOGIN</router-link></li>
          <li class="dropdown" v-if="user">
            <a href="#" class="btn btn-link bold font-18 dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">{{ user.name }} <span class="caret"></span></a>
            <ul class="dropdown-menu">
              <li><router-link :to="{name: 'my_rents'}"><i class="fa fa-fw fa-exchange"></i> Minhas locações</router-link></li>
              <li><router-link :to="{name: 'cancel_account'}"><i class="fa fa-fw fa-close"></i> Cancelar conta</router-link></li>
              <li role="separator" class="divider"></li>
              <li><a href="#" @click="logout()"><i class="fa fa-fw fa-sign-out"></i> Sair</a></li>
            </ul>
          </li>
        </ul>
        <ul v-show="$route.name === 'home' && user === false "  class="nav navbar-nav navbar-right hidden-xs hidden-sm">
          <li>
            <a href="https://api.whatsapp.com/send?phone=5531998038196&text=Olá, gostaria de saber mais sobre a Loca.Shop." target="_blank" class="btn btn-link bold font-20">
              <i class="fa fa-whatsapp"></i> (31) 99803-8196
            </a>
          </li>
          <li>&nbsp;&nbsp;&nbsp;</li>
          <li><router-link :to="{name: 'company_registration'}" class="btn btn-success bold font-18 shake">EXPERIMENTE GRÁTIS</router-link></li>
        </ul>
      </header>
    </div>
  </div>
</template>

<script>
  import * as config from '../../config.js'
  import {mapState, mapActions} from 'vuex'

  export default{
    name: 'PartialHeader',
    components: {},
    data () {
      return {
        fullWidth: document.documentElement.clientWidth,
        adminURL: config.adminURL
      }
    },
    computed: {
      apiDomain () {
        return config.apiDomain
      },
      routeName () {
        return this.$route.name || ''
      },
      ...mapState({
        user: state => state.user,
        city: state => state.city
      })
    },
    mounted: function () {
      window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.handleResize)
    },
    methods: {
      logout () {
        this.handleLogout()
      },
      toggleDrawer () {
        this.$emit('toggle-drawer', true)
      },
      handleResize (event) {
        this.fullWidth = event.target.innerWidth
      },
      ...mapActions(['unsetUser'])
    }
  }
</script>



// WEBPACK FOOTER //
// PartialHeader.vue?1b89b614